<template>
    <app-layout>
      <template #header>
        <h1>Editar Dia</h1>
      </template>
        <div class="flex items-center justify-center h-screen bg-gray-100">
            <div class="flex items-center justify-center h-screen bg-gray-100">
                <div class="bg-white py-6 rounded-md px-10 max-w-lg shadow-md">
                    <form @submit.prevent="submit">
                        <div class="space-y-4 mt-6">
                            <div class="w-full">
                                <input 
                                id="nombre"
                                v-model="form.nombre"
                                placeholder="Nombre" class="px-4 py-2 bg-gray-50" />
                            </div>
                        </div>
                        <Link
                            :href="route('dias.index')"
                            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 border border-blue-500 rounded">
                            Regresar
                        </Link>
                        <button
                            :type="submit"
                            class="bg-red-500 hover:bg-green-700 text-white font-bold py-1 px-2 border border-green-500 rounded">
                                Guardar
                        </button>
                    </form> 
                </div>
            </div>
        </div>

    </app-layout>
</template>
<script>
import AppLayout from "@/Layouts/AppLayout"
import { defineComponent } from 'vue'
import { Head, Link } from '@inertiajs/inertia-vue3';
export default defineComponent({
    props: ["dia"],
    components: {
        AppLayout,
        Head,
        Link,
    },
    data(){
        return{
            form:{
                nombre: this.$props.dia.nombre,
            }
        }
    },
    methods: {
        submit(){
            this.$inertia.put(route("dias.update", this.$props.dia.id),this.form);
            Toast.fire({
                icon: 'success',
                title: 'Dia Editado'
            })
        },
    },
});
</script>